<ion-content class="bg-color ion-content user">
  <div class="com-content">
    <div class="content-breadcrumb">
      <ul class="breadcrumb">
        <li *ngFor="let itemList of breadcrumbList" class="breadcrumb-item">
          <a routerLink="{{ itemList.url }}">
            {{ itemList.label }}
          </a>
        </li>
      </ul>
    </div>
    <div class="content-grid">
      <mat-card>
        <mat-card-title class="mc-title">
          <span class="table-header">Activity Logs</span>
        </mat-card-title>
        <mat-card-content class="mc-content">
          <div class="table-container">
            <div class="filter-container">
              <div class="select-activity-logs">
                <mat-form-field class="mat-dropdown" appearance="outline">
                  <mat-label>Select Log</mat-label>
                  <mat-select class="activity-log" [(ngModel)]="selctedUser" (selectionChange)="selectActivityLogs($event)">
                    <mat-option *ngFor="let activeUser of activityLogs" [value]="activeUser.id">
                      {{ activeUser.first_name+" "+activeUser.last_name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="calendar">
                <mat-form-field class="calendar-data" appearance="outline">
                  <input matInput [matDatepicker]="fromDate" placeholder="From Date" 
                  [(ngModel)]="from_date" [min]="minDate" [max]="currentDate" readonly>
                  <mat-hint>DD/MM/YYYY</mat-hint>
                  <mat-datepicker-toggle matIconSuffix [for]="fromDate"></mat-datepicker-toggle>
                  <mat-datepicker #fromDate  ></mat-datepicker>
                </mat-form-field>
                <mat-form-field class="calendar-data" appearance="outline">
                  <mat-label>Select End Date</mat-label>
                  <input matInput [matDatepicker]="toDate" placeholder="To Date" 
                  [(ngModel)]="to_date" [min]="from_date?from_date:minDate" [max]="currentDate" 
                  (dateChange)="activityLogsList($event)" readonly>
                  <mat-hint>DD/MM/YYYY</mat-hint>
                  <mat-datepicker-toggle matIconSuffix [for]="toDate"></mat-datepicker-toggle>
                  <mat-datepicker #toDate ></mat-datepicker>
                </mat-form-field>
              </div>
              <div class="button-container">
                <button mat-raised-button class="remove-button" (click)="clearLog()"> Clear </button>
              </div>           
            </div>
          </div>

          <div class="table-container">
            <table mat-table matTableResponsive [dataSource]="userActivityLogs">
              <ng-container matColumnDef="first_name">
                <th mat-header-cell *matHeaderCellDef> First Name </th>
                <td mat-cell *matCellDef="let element">{{element.first_name}} </td>
              </ng-container>

              <ng-container matColumnDef="last_name">
                <th mat-header-cell *matHeaderCellDef> Last Name </th>
                <td mat-cell *matCellDef="let element">{{element.last_name}} </td>
              </ng-container>

              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef> Action </th>
                <td mat-cell *matCellDef="let element">{{element.action}} </td>
              </ng-container>

              <ng-container matColumnDef="visited_date">
                <th mat-header-cell *matHeaderCellDef> Visited Date </th>
                <td mat-cell *matCellDef="let element">{{element.visited_date | date: 'medium'}} </td>
              </ng-container>

              <ng-container matColumnDef="visited_page_url">
                <th mat-header-cell *matHeaderCellDef> Visited Page </th>
                <td mat-cell *matCellDef="let element">{{element.visited_page_url}} </td>
              </ng-container>
              
              <tr mat-header-row *matHeaderRowDef="userActivityLogsColumns; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: userActivityLogsColumns;"></tr>
            </table>
          </div>
        </mat-card-content>
        <ion-infinite-scroll threshold="150px" (ionInfinite)="loadMore($event)">
          <!-- *ngIf="total_records > 10" -->
          <ion-infinite-scroll-content loadingSpinner="dots">
          </ion-infinite-scroll-content>
        </ion-infinite-scroll>
      </mat-card>
    </div>
    <app-footer></app-footer>
  </div>
</ion-content>